import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

const ModalContent = (props) => {
  const { heading, body } = props;

  return (
    <div>
      <Typography.Paragraph
        style={{
          color: '#DDE3E7',
          fontSize: 16,
          fontWeight: 500,
        }}
      >
        {heading}
      </Typography.Paragraph>
      <Typography.Paragraph
        style={{
          color: '#DDE3E7',
        }}
      >
        {body}
      </Typography.Paragraph>
    </div>
  );
};

ModalContent.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
};

ModalContent.defaultProps = {
  heading: '',
  body: '',
};

export default ModalContent;
